// Skeleton feed — renders while posts are loading
// Matches the shape of InlineFeedPost cards

export default function SkeletonFeed({ count = 4 }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={s.card}>
          <div style={s.header}>
            <div style={{ ...s.shimmer, width: 60, height: 10, borderRadius: 4 }} />
            {i === 0 && <div style={{ ...s.shimmer, width: 80, height: 10, borderRadius: 4 }} />}
          </div>
          <div style={{ ...s.shimmer, width: `${75 + (i % 3) * 8}%`, height: 22, borderRadius: 4, marginBottom: 10 }} />
          <div style={{ ...s.shimmer, width: '90%', height: 14, borderRadius: 4, marginBottom: 6 }} />
          <div style={{ ...s.shimmer, width: '70%', height: 14, borderRadius: 4, marginBottom: 20 }} />
          <div style={s.meta}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{ ...s.shimmer, width: 28, height: 28, borderRadius: '50%' }} />
              <div style={{ ...s.shimmer, width: 80, height: 10, borderRadius: 4 }} />
            </div>
            <div style={{ ...s.shimmer, width: 50, height: 10, borderRadius: 4 }} />
          </div>
        </div>
      ))}
    </div>
  )
}

const s = {
  card: {
    background: 'var(--paper)',
    border: '1px solid var(--rule)',
    borderRadius: 12,
    padding: '1.5rem',
    overflow: 'hidden',
  },
  header: { display: 'flex', gap: 8, marginBottom: 14 },
  meta: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  shimmer: {
    background: 'linear-gradient(90deg, var(--rule) 25%, var(--cream) 50%, var(--rule) 75%)',
    backgroundSize: '200% 100%',
    animation: 'skeleton-shimmer 1.4s ease infinite',
    flexShrink: 0,
  },
}
